/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid regular expression — check your pattern.`)
};

const es_fr_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expresión regular inválida — verifica tu patrón.`)
};

const de_fr_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültiger regulärer Ausdruck — überprüfen Sie Ihr Muster.`)
};

const nl_fr_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeldige reguliere uitdrukking — controleer uw patroon.`)
};

const fr_fr_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expression régulière invalide — vérifiez votre modèle.`)
};

const it_fr_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espressione regolare non valida — verifica il tuo schema.`)
};

const pt_br2_fr_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expressão regular inválida — verifique seu padrão.`)
};

const pt_fr_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expressão regular inválida — verifique o padrão.`)
};

const ja_fr_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効な正規表現です — パターンを確認してください。`)
};

const zh_fr_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正则表达式无效 — 请检查你的模式。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_error(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_error", locale)
	if (locale === "en") return en_fr_error(inputs)
	if (locale === "es") return es_fr_error(inputs)
	if (locale === "de") return de_fr_error(inputs)
	if (locale === "nl") return nl_fr_error(inputs)
	if (locale === "fr") return fr_fr_error(inputs)
	if (locale === "it") return it_fr_error(inputs)
	if (locale === "pt-BR") return pt_br2_fr_error(inputs)
	if (locale === "pt") return pt_fr_error(inputs)
	if (locale === "ja") return ja_fr_error(inputs)
	return zh_fr_error(inputs)
};